// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","desc":"Hero_desc__gGu12"};